<app-navbar [class.hidden]="!showNavbar" #navbar></app-navbar>
<div class="app-container" *ngIf="!navbar.showNavigation">
    <router-outlet></router-outlet>
</div>
